export enum FileItemType {
  DIR = 'dir',
  FILE = 'file',
}

export enum SaveStatus {
  IDLE = 'idle',
  UNSAVED = 'unsaved',
  SAVING = 'saving',
  SAVED = 'saved',
}

export enum PreviewType {
  IMAGE = 'image',
  TEXT = 'text',
  PDF = 'pdf',
  OFFICE = 'office',
  OFFICE_FSE = 'officefse',
  OFFICE_FSV = 'officefsv',
  DOC = 'doc',
  VIDEO = 'video',
  AUDIO = 'audio',
  DEFAULT = 'default',
  ERROR = 'error',
  UNKNOWN = 'unknown',
}

export enum PreviewNotice {
  NONE = 0,
  FILE_TOO_LARGE = 1,
  PREVIEWS_DISABLED = 2,
  STREAMING_DISABLED = 3,
}

export enum BlendEvent {
  CHANGE_SHARE_OWNER = 'change_share_owner',
  DISABLE_SHARE = 'disable_share',
  INVITE_TO_SHARE = 'invite_to_share',
  REMOVE_FROM_SHARE = 'remove_from_share',
  UPDATE_SHARE_PERMISSIONS = 'update_share_permissions',
  SIGN_IN = 'SignIn',
  IDENTIFY = '$identify',
  BUTTON_CLICKED = 'button_clicked',
  DELETE_ACCOUNT = 'Delete Account',
  CONTACT_SUPPORT = 'Contact Support',
  HELP_EVENT = 'Help Event',
  GET_HELP_EVENT = 'Get Help Event',
  CANCEL_HELP = 'Cancel Help',
  ADD_FAVORITE_TAG = 'Add Favorite Tag',
  REMOVE_FAVORITE_TAG = 'Remove Favorite Tag',
  RESTORE = 'restore',
  RESTORE_VERSION = 'restore_version',
  PURGE_ALL = 'purge_all',
  BILLING_PROFILE_REMOVED = 'Billing Profile Removed',
  VIEW_FAVORITE_LIST = 'View Favorite List',
  SYNC_KNOWLEDGEBASE = 'Sync Knowledgebase',
  UPLOAD_FILE = 'Upload File',
  CREATE_FILE = 'Create File',
  DOWNLOAD_FILE = 'Download File',
  ZIP_DOWNLOAD_INITIATED = 'Zip Download Initiated',
  ZIP_DOWNLOAD_COMPLETED = 'Zip Download Completed',
  ZIP_DOWNLOAD_FAILED = 'Zip Download Failed',
  SHARE_LINK_ZIP_DOWNLOAD_INITIATED = 'Share Link Zip Download Initiated',
  SHARE_LINK_ZIP_DOWNLOAD_COMPLETED = 'Share Link Zip Download Completed',
  SHARE_LINK_ZIP_DOWNLOAD_FAILED = 'Share Link Zip Download Failed',
  FILE_STREAM_INITIATED = 'File Stream Initiated',
  FILE_STREAM_COMPLETED = 'File Stream Completed',
  FILE_STREAM_CANCELLED = 'File Stream Cancelled',
  FILE_STREAM_FAILED = 'File Stream Failed',
  FILE_STREAM_NOT_STARTED = 'File Stream Not Started',
  VIEW_FILE = 'View File',
  EDIT_FILE_OFFICE = 'Edit File Office',
  EDIT_FILE_TEXT = 'Edit Text File',
  SAVE_FILE_TEXT = 'Save Text File',
  SHARE_LINK = 'Share Link',
  JOINED_SHARE = 'joined_share',
  DISMISS_PENDING_SHARE_INVITATION = 'dismiss_pending_share_invitation',
  SHARED_FOLDER_CREATED = 'shared_folder_created',
  SAVE_LINK_SETTINGS = 'save_link_settings',
  UPGRADE_INQUIRY = 'Upgrade Inquiry',
  ANALYTICS_OPT_IN = 'Opt In',
  ANALYTICS_OPT_OUT = 'Opt Out',
  NEW_UI_OPT_IN = 'New UI Opt In',
  NEW_UI_OPT_OUT = 'New UI Opt Out',
  SIGN_UP = 'SignUp',
  PURCHASE_COMPLETED = 'Purchase Completed',
  SUB_USER_ADDED = 'sub_user_added',
  SUB_USER_ROLE_UPDATED = 'sub_user_role_updated',
  SUB_USER_PASSWORD_RESET = 'sub_user_password_reset',
  SUB_USER_REMOVED = 'sub_user_removed',
  NEW_ROLE_CREATED = 'new_role_created',
  ROLE_DELETED = 'role_deleted',
  UPDATE_ROLE_SETTINGS = 'update_role_settings',
  UPLOAD = 'upload',
  DUPLICATE_ITEM = 'duplicate_item',
  RENAME_ITEM = 'rename_item',
  DELETE_ITEMS = 'delete_items',
  DELETE_ITEM = 'delete_item',
  MOVE_ITEMS = 'move_items',
  COPY_ITEMS = 'copy_items',
  COPY_ITEM = 'copy_item',
  BILLING_PROFILE_ADDED = 'billing_profile_added',
  REWARD_REDEEMED = 'reward_redeemed',
  CHANGE_ACCOUNT_SETTING = 'change_account_setting',
  SAVE_BRANDING_CHANGES = 'save_branding_changes',
  RETRY_UPLOAD_BUTTON_DISPLAYED = 'retry_upload_button_displayed',
  ERROR = 'Error',
  PASSWORD_CHANGE = 'Password Change',
  MIGRATE = 'Migrate',
  PRIVACY_CENTER_CONFIG = 'Privacy Center Config',
  PRIVACY_CENTER_OPENED = 'Privacy Center Opened',
  PREVIEWER_PREFERENCE = 'View Preferences Selection',
}

export enum OfficeEditEntryPoint {
  FILES = 'files',
  VAULT = 'vault',
  PREVIEW = 'preview',
  LINK = 'link',
  STARRED = 'starred',
}

export enum BlendProperties {
  LINK_TYPE_FOLDER = 'folder',
  LINK_PERMISSION_VIEW = 'view only',
  LINK_PERMISSION_DOWNLOAD = 'view & download',
  LINK_PERMISSION_EDITABLE = 'view, downlaod & edit',
  LINK_COMMENTS_DISABLED = 'disabled',
  LINK_COMMENTS_ENABLED_AUTH = 'enabled for authenticated users',
  LINK_COMMENTS_ENABLED_ALL = 'enabled for all users',
  LINK_PERMISSION_HIDE_FOLDER_CONTENTS = 'LINK_PERMISSION_HIDE_FOLDER_CONTENTS',
  LINK_PERMISSION_VIEW_FOLDER_CONTENTS = 'LINK_PERMISSION_VIEW_FOLDER_CONTENTS',
  LINK_PERMISSION_DOWNLOAD_FOLDER_CONTENTS = 'LINK_PERMISSION_DOWNLOAD_FOLDER_CONTENTS',
  LINK_PERMISSION_EDITABLE_FOLDER_CONTENTS = 'LINK_PERMISSION_EDITABLE_FOLDER_CONTENTS',
}

export enum PrivacyBlendProperties {
  EXTENDED_PREVIEWS = 'Extended previews',
  MICROSOFT_EDITOR = 'Microsoft editor',
  DOWNLOAD_ACCELERATOR = 'Download accelerator',
  LINK_COMPATIBILITY = 'Link compatibility',
  MEDIA_STREAMING = 'Media streaming',
  EXTENDED_WEB_THUMBNAILS = 'Extended web thumbnails',
  EMAIL_BASED_PASSWORD_RESET = 'Email-based password reset',
}

export enum PrivacyCenterSource {
  SECURITY_SETTINGS = 'Security settings',
  EDITING_PREFERENCES = 'Editing preferences',
  PREVIEWS_DISABLED_NOTICE = 'Previews disabled notice',
  STREAMING_DISABLED_NOTICE = 'Media streaming disabled notice',
  DIRECT_LINK = 'Direct link',
}

export enum PermissionActions {
  CREATED_AT = 'created_at',
  UPDATED_AT = 'updated_at',
  MANAGE_USERS = 'manageUsers',
  VIEW_USERS = 'viewUsers',
  ADD_EDIT_USERS = 'addEditUsers',
  MANAGE_ROLES = 'manageRoles',
  VIEW_ROLES = 'viewRoles',
  ADD_EDIT_ROLES = 'addEditRoles',
  VIEW_BILLING = 'viewBilling',
  MANAGE_BILLING = 'manageBilling',
  PURGE_FILES = 'purgeFiles',
  FORCE_2FA_ON_FIRST_LOGIN = 'force2faOnFirstLogin',
  DISABLE_EMAIL_CHANGE = 'disableEmailChange',
  SHARE_LINKS = 'sharelinks',
  SHARE_LINK_EXPIRY = 'shareLinkExpiry',
  DEFAULT_SHARE_LINK_EXPIRY_TIME = 'shareLinkExpiry',
  SHARE_LINK_PASSWORD = 'shareLinkPassword',
  DEFAULT_SHARE_LINK_PASSWORD = 'shareLinkPassword',
  SHARE_FOLDERS = 'shareFolders',
}

export enum PlanType {
  BPT = 'business-teams',
  PER = 'personal',
  LPER = 'personal-legacy',
  PS = 'business-solo',
  PSP = 'pro-solo-pro',
  BPTU = 'business-teams-advanced',
  BPTSP = 'business-teams-plus',
  BPTUP = 'business-teams-advanced-plus',
  FREE = 'free',
}

export enum WebpathActionType {
  COPY = 'Copy',
  MOVE = 'Move',
  JOINSHARE = 'Save and join',
}

export enum FieldTypes {
  TEXTBOX = 'textbox',
  DROPDOWN = 'dropdown',
  RADIOBUTTON = 'radiobutton',
}

export enum FieldIdentities {
  ROLENAME = 'roleName',
  CANPURGEFILES = 'canPurgeFiles',
  CANMANAGEUSERS = 'canManageUsers',
  CANMANAGEROLES = 'canManageRoles',
  CANVIEWUSERS = 'canViewUsers',
  CANADDEDITUSERS = 'canAddEditUsers',
  CANVIEWROLES = 'canViewRoles',
  CANADDEDITROLES = 'canAddEitRoles',
  CANVIEWBILLING = 'canViewBilling',
  CANMANAGEBILLING = 'canManageBilling',
  CANFORCE2FALOGIN = 'canForce2faLogin',
  CANDISABLEEMAILCHANGE = 'canDisableEmailChange',
  CANSHARELINKS = 'CanSharelinks',
  CANSHARELINKEXPIRYREQUIRED = 'CanShareLinkExpiryRequired',
  DEFAULTSHARELINKEXPIRYTIME = 'DefaultShareLinkExpiryTime',
  CANSHARELINKPASSWORDREQUIRED = 'CanShareLinkPasswordRequired',
  DEFAULTSHARELINKPASSWORD = 'DefaultShareLinkPassword',
  CANSHAREFOLDERS = 'canShareFolders',
}

export enum ModalCloseStates {
  USER_ROLE_UPDATED = 'userRoleUpdated',
  REMOVED = 'removed',
  PASSWORD_UPDATED = 'passwordUpdated',
}

export enum PermissionObjects {
  METADATA = '_metadata',
  ADMIN = 'admin',
  BILLING = 'billing',
  FILES = 'files',
  SETTINGS = 'settings',
  SHARE = 'share',
  FOLDERS = 'folders',
}

export enum PageTitles {
  DASHBOARD = 'Dashboard',
  FILES = 'Files',
  VAULT = 'Vault',
  SHARES = 'Shares',
  RECENTS = 'Recents',
  STARRED = 'Starred',
  TRASH = 'Trash',
  USERS_ROLES = 'Users & roles',
  USERS = 'Users',
  ROLES = 'Roles',
  SETTINGS = 'Settings',
  FILE_HISTORY = 'Version history',
}

export const pageTitleMap: Record<string, PageTitles> = {
  dashboard: PageTitles.DASHBOARD,
  files: PageTitles.FILES,
  vault: PageTitles.VAULT,
  shares: PageTitles.SHARES,
  recents: PageTitles.RECENTS,
  starred: PageTitles.STARRED,
  trash: PageTitles.TRASH,
  users: PageTitles.USERS_ROLES,
  settings: PageTitles.SETTINGS,
  'file-history': PageTitles.FILE_HISTORY,
};

export enum SnackBarLeadIcon {
  DEFAULT = 'info',
  WARNING = 'warning',
  CRITICAL = 'info',
  SUCCESS = 'success',
}

export const snackBarLeadIconMap: Record<string, string> = {
  default: SnackBarLeadIcon.DEFAULT,
  warning: SnackBarLeadIcon.WARNING,
  critical: SnackBarLeadIcon.CRITICAL,
  success: SnackBarLeadIcon.SUCCESS,
};

export enum StorageBackend {
  CEPH = 'ceph',
  ZFS = 'zfs',
}

export const CONSTANTS = {
  PPT_BLOB_TYPE: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  EXCEL_BLOB_TYPE: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  DOCX_BLOB_TYPE: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8',
  TEXT_BLOB_TYPE: 'text/plain',
  DOC_FILE_TYPE: '.docx',
  PPT_FILE_TYPE: '.pptx',
  EXCEL_FILE_TYPE: '.xlsx',
  TEXT_FILE_TYPE: '.txt',
  DOCUMENT_TYPE_LIST: ['Word Document', 'PowerPoint Presentation', 'Excel Worksheet', 'Text File'],
  FILE_TYPE_LIST: ['.docx', '.pptx', '.xlsx', '.txt'],
  DOCUMENT_SVG_IMAGE_LIST: ['mime-doc.svg', 'mime-presentation.svg', 'mime-spreadsheet.svg', 'mime-txt.svg'],
  DOCUMENT_ICON_IMAGE_LIST: ['file-type-docx', 'file-type-ppt', 'file-type-xlsx', 'file-document'],
  DUMMY_TEMPLATES_PATH: './assets/dummyTemplates/',
  DUMMY_MS_WORD_FILE_NAME: 'template.docx',
  DUMMY_MS_EXCEL_FILE_NAME: 'template.xlsx',
  DUMMY_MS_PPT_FILE_NAME: 'template.pptx',
  DUMMY_TEXT_FILE_NAME: 'template.txt',

  MAX_FILE_NAME_LEN: 248,

  // Default storage engine/backend used for uploads when no
  // USER_STORAGE_BACKEND flag or link owner storage value is available.
  DEFAULT_STORAGE_BACKEND: StorageBackend.ZFS,
};
export enum MoveActionStep {
  BLANK = -1,
  SELECT_DESTINATION_FOLDER = 1,
  TRANSFER = 2,
  ONE_CONFLICT = 3,
  MANY_CONFLICT = 4,
  FIX_CONFLICT = 5,
  NEW_FOLDER = 6,
  JOIN_SHARE = 7,
}

export enum MoveConflict {
  ONE_CONFLICT = 1,
  MANY_CONFLICT = 2,
  FIX_CONFLICT = 3,
}
export enum ShareDetailsOpenState {
  CLOSE_STATE = -1,
  MEMBER_LIST = 1,
  OPTIONS = 2,
  CHOOSE_OWNER = 3,
  MEMBER_REMOVE = 4,
  REMOVE_SHARING = 5,
  LEAVE_SHARE = 6,
  MEMBER_PERMISSION = 7,
  MEMBER_INVITE = 8,
  VERIFY_EMAIL = 9,
}

export enum SyncUrls {
  DESKTOP_APP = 'https://www.sync.com/help/category/desktop-app/',
}

export enum ENTITLEMENT {
  RBAC = 'rbac',
  HIPAA = 'hipaa',
  EMAIL_LINKS = 'email-links',
  SHARE_INVITE_CUSTOM_MESSAGE = 'share-invite-custom-message',
  ACCUSOFT = 'accusoft',
  COMMENT = 'comment',
  BRANDING = 'branding',
  PHONE_SUPPORT = 'phone-support',
  SHARE_FOLDER_READONLY = 'share-folder-readonly',
  MOBILE_OFFLINE_FOLDERS = 'mobile-offline-folders',
  MOBILE_CAMERA_CUSTOM_FOLDER = 'mobile-camera-custom-folder',
  FAVORITES = 'favorites',
  EMAILS = 'emails',
  SHARE_MEMBER_LIMIT = 'share-member-limit',
  LINK_VIEWS = 'link-views',
  LINK_FEATURES = 'link-features',
  LINKS = 'links',
  TRASH = 'trash',
  HISTORY = 'history',
  DEVICES = 'devices',
  SHARES = 'shares',
  BANDWIDTH = 'bandwidth',
  STORAGE = 'storage',
  LEGACY_BONUS_STORAGE = 'legacy-bonus-storage',
  MSOFFICE = 'msoffice',
  SUPPORT = 'support',
}

export enum Region {
  US = 'US',
  GLOBAL = 'GLOBAL',
  FORCEGLOBAL = 'FORCEGLOBAL',
  FORCEUS = 'FORCEUS',
  USCENTRAL = 'us-central',
  CACENTRAL = 'ca-central',
}

export enum Entity {
  US = 'US',
  GLOBAL = 'GLOBAL',
}
export enum DialogLinkOpenStates {
  CREATE_LINK_ADVANCED = 0,
  MANAGE_LINK = 1,
  LINK_SETTINGS = 2,
  DELETE_LINK = 3,
  SHARE_LINK = 4,
  CREATE_LINK = 5,
  ERROR = 99,
}

export enum LinkConsumeOpenStates {
  LOADING = 0,
  FILE_LIST = 1,
  PASSWORD_REQUIRED = 2,
  ERROR = 3,
}

export enum LinkPreviewMode {
  ALLOW_DOWNLOAD = 0,
  VIEW_ONLY = 1,
  PDF_WATERMARK = 8,
}

export enum FeatureFlags {
  LEGACY_TEAMS_MIGRATION = 'LEGACY_TEAMS_MIGRATION',
  PRIVACY_CENTER = 'PRIVACY_CENTER',
  CONCURRENT_UPLOAD = 'CP_CONCURRENT_UPLOAD',
  E2EE_ZIP_DOWNLOAD = 'CP_E2EE_ZIP_DOWNLOAD',
  DISABLE_WEB_THUMBNAILS = 'CP_DISABLE_WEB_THUMBNAILS',
  USER_STORAGE_BACKEND = 'USER_STORAGE_BACKEND',
  ALLOW_DISABLE_PASSWORD_RESET = 'CP_ALLOW_DISABLE_PASSWORD_RESET',
  SINGLE_PAGE_CHECKOUT = 'CP_SINGLE_PAGE_CHECKOUT',
}
